import { render, staticRenderFns } from "./PlaylistGroupView.vue?vue&type=template&id=40bc9ff6&scoped=true"
import script from "./PlaylistGroupView.vue?vue&type=script&lang=js"
export * from "./PlaylistGroupView.vue?vue&type=script&lang=js"
import style0 from "./PlaylistGroupView.vue?vue&type=style&index=0&id=40bc9ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc9ff6",
  null
  
)

export default component.exports